import { Dispatch, createContext, useMemo, useReducer } from "react";
import {
  standAloneReducer,
  initialState,
} from "./StandAloneReducer";
import { Action, StandAloneState } from "../../../models/StandAloneData";

type standAloneContextType = {
  state: StandAloneState;
  dispatch: Dispatch<Action>;
};

const StandALoneContext = createContext<standAloneContextType>({
  state: initialState,
  dispatch: (action: Action) => {
    throw new Error(`Default context used unexpectedly, check you have a provider`);
}
});

export const StandAloneProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(standAloneReducer, initialState);
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <StandALoneContext.Provider value={contextValue}>
      {children}
    </StandALoneContext.Provider>
  );
};

export default StandALoneContext;
